module.exports = __webpack_public_path__ + "static/media/jumbotron.1f4b7712.PNG";